import { gql } from '@apollo/client';

export const fetchLinkedEntitlementsForTable = gql`
  query fetchLinkedEntitlementsForTable($id: String!, $searchLinkedEntitlementParams: SearchLinkedEntitlementParams!) {
    entitlementDetails(id: $id) {
      id
      transactionAccountId
      linkedEntitlements(searchLinkedEntitlementParams: $searchLinkedEntitlementParams) {
        entitlementId
        productId
        entitlementNumber
        productName
        billingCycle
        billingFrequency
        latestPeriodEndDate
        endTimestamp
        nextBillingTimestamp
        offeringId
        subscriptionId
        billingStatus
        isApp
        transactionAccountId
        billingGroupId
        edition
        isSandbox
        parentSen
        logoId
        userTier
        offering {
          pricingType
        }
        relatesFromEntitlements {
          entitlementId
          relationshipType
        }
      }
    }
  }
`;
